import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { inject } from '@angular/core';

export const AdminGuard: CanActivateFn = (route, state) => {
  console.log("AdminGuard canActivate...");

  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const isAdmin = authService.userIsAdmin();

  if (isAdmin) {
    // logged in so return true
    // authService.setupNiederlassung();
    return true;
  } else {
    // not logged in so redirect to login page with the return url
    router.navigate(['/app/dashboard'], { queryParams: { returnUrl: state.url } });
    return false;
  }
};
